import { notify } from '../../shared';
import { useRequest } from '../../hooks';
import { deleteContacts } from '../../api';
import { useView, useConfirm } from '../../molecules';
import { wipeContact, startCampaignForContacts } from '../../api';
// import { wipeContact, startCampaignForContact } from '../../api';
import type { ContactItemType } from '../../templates';

// const DELAY = 5 * 1_000;
// const startCampaignForContactWithDelay = async (
//   ...params: Parameters<typeof startCampaignForContact>
// ) => {
//   const result = await startCampaignForContact(...params);
//   await new Promise(resolve => setTimeout(resolve, DELAY));

//   return result;
// };

export const useContactActions = (
  onRefresh: () => void,
  onSelection: (ids: string[]) => void
) => {
  const { element: startElement, open: handleOpenStart } = useConfirm();
  const [handleStartCampaign, starting] = useRequest(
    (_signal, item: ContactItemType) => startCampaignForContacts([item.id]),
    {
      deps: [],
      onSuccess: _data => {
        notify.success('Started Campaign');
        onRefresh();
      },
      onError: () => {
        notify.error('Failed to start Campaign');
      },
    }
  );

  const { element: wipeElement, open: handleOpenWipe } = useConfirm();
  const [handleWipeContact, wiping] = useRequest(
    (_signal, item: ContactItemType) => wipeContact(item.id),
    {
      deps: [],
      onSuccess: data => {
        notify.success(data?.message || 'Contact data was cleaned');
        onRefresh();
      },
      onError: () => {
        notify.error('Failed to crean Contact data');
      },
    }
  );

  const { element: bulkStartElement, open: handleOpenBulkStart } = useConfirm();
  const [handleStartBulkCampaign, startingBulk] = useRequest(
    (_signal, ids: string[]) => startCampaignForContacts(ids),
    {
      deps: [],
      onSuccess: data => {
        const message = `Started ${data.success_count} contact(s). Skipped: ${data.skipped_count}. Not found: ${data.not_found_count}.`;
        notify.success(message);

        onRefresh();
        onSelection([]);
      },
      onError: e => {
        notify.error(e?.message || 'Bulk start failed');
      },
    }
  );

  const { element: bulkDeleteElement, open: handleOpenBulkDelete } =
    useConfirm();
  const [handleBulkDelete, deletingBulk] = useRequest(
    (_signal, ids: string[]) => deleteContacts(ids),
    {
      deps: [],
      onSuccess: data => {
        const message = data?.message || 'Deleted contacts';
        notify.success(message);

        onRefresh();
        onSelection([]);
      },
      onError: e => {
        notify.error(e?.message || 'Bulk delete failed');
      },
    }
  );

  const { element: stateDetailsElement, handleView } = useView();

  return {
    progress: starting || wiping || startingBulk || deletingBulk,

    bulkStartElement,
    openBulkStart: (ids: string[]) => {
      return handleOpenBulkStart({
        confirmText: 'Start',
        confirmType: 'primary',
        title: 'Start Outreach',
        text: `Start outreach for ${ids.length} contact(s)? They will be marked as AI_READY_TO_START and picked up automatically.`,

        onConfirm: () => handleStartBulkCampaign(ids),
      });
    },

    startElement,
    openStart: (item: ContactItemType) => {
      return handleOpenStart({
        text: `Are you sure you want to start a campaign for ${item.email}?`,
        onConfirm: () => handleStartCampaign(item),
      });
    },

    wipeElement,
    openWipe: (item: ContactItemType) => {
      return handleOpenWipe({
        title: 'Clean Contact Data',
        text: `This action deletes ALL data (tasks, messages, events, states) for ${item.email} but keeps the contact. Are you sure?`,
        onConfirm: () => handleWipeContact(item),
      });
    },

    bulkDeleteElement,
    openBulkDelete: (ids: string[]) => {
      return handleOpenBulkDelete({
        confirmText: 'Delete',
        confirmType: 'danger',
        title: 'Delete Contacts',
        text: `Delete ${ids.length} contact(s)?`,

        onConfirm: () => handleBulkDelete(ids),
      });
    },

    stateDetailsElement,
    handleView,
  };
};
